import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient, InMemoryCache } from '@apollo/client/core'
import { httpEndpoint } from '@/providers/apollo/http-link'
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev'
import { getHttpLink } from './http-link'

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages()
  loadErrorMessages()
}

// import sendSlackFireNotifier from '@/plugins/slack-fire-notifier'

// Install the vue plugin
Vue.use(VueApollo)

// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'))

Vue.prototype.$filesRoot = filesRoot

// Call this in the Vue app file
export function createProvider(options = {}) {
  const defaultClient = new ApolloClient({
    link: getHttpLink(),
    cache: new InMemoryCache(),
    ssrMode: false,
    persisting: false,
    ...options,
  })

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient,
    async errorHandler(error, vm, info, operation, request) {
      console.log('GQL ERROR - %cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error)
      if (error.graphQLErrors && error.graphQLErrors.some((err) => err.message.startsWith('authentication.error'))) {
        window.location.replace('/#/expired-session')
      }
      if (error.graphQLErrors && error.graphQLErrors.some((err) => err.message.startsWith('invalid.session'))) {
        window.location.replace('/#/expired-session')
      }
    },
  })

  return apolloProvider
}
